import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
import styled, { css } from 'styled-components';
import { variant } from 'styled-system';
import { get } from '../../styles/constant';
import Box from '../Box';
const ratingsVariants = variant({
  prop: 'variant',
  variants: {
    info: {
      color: get('colors.feedback.info.normal')
    },
    success: {
      color: get('colors.feedback.success.normal')
    },
    warning: {
      color: get('colors.feedback.warning.normal')
    },
    error: {
      color: get('colors.feedback.danger.normal')
    }
  }
});
const IconDefaultStyle = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  z-index: 1;\n  width: ", ";\n  height: ", ";\n  display: inline-flex;\n  justify-content: space-around;\n  top: 50%;\n  transform: translateY(-50%);\n"])), get('iconSize.small'), get('iconSize.small'));
const Prefix = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  right: unset;\n  left: ", ";\n  color: ", ";\n  font-size: ", ";\n"])), IconDefaultStyle, get('space.12'), get('colors.functional.grey.600'), props => props.fit === 'small' ? get('fontSizes.14') : get('fontSizes.16'));
const Suffix = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  left: unset;\n  color: ", ";\n  font-size: ", ";\n  right: ", ";\n"])), IconDefaultStyle, get('colors.functional.grey.600'), props => props.fit === 'small' ? get('fontSizes.14') : get('fontSizes.16'), get('space.17'));
export { Prefix, Suffix };
const Wrapper = styled(Box)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: ", ";\n\n  button {\n    color: ", ";\n    ", "\n    padding: 0;\n    margin: 0;\n    background: transparent;\n    border: 0;\n    min-width: ", ";\n    &:hover {\n      background-color: transparent;\n    }\n    &:focus,\n    &:focus-visible {\n      outline: 0;\n      border: 0;\n    }\n  }\n\n  button.active {\n    color: ", ";\n    ", "\n  }\n"])), props => props.width ? "".concat(props.width, "%") : '100%', props => props.strokeColor, ratingsVariants, get('space.24'), props => props.fillColor || get('colors.secondary.orange.300'), ratingsVariants);
const Area = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  z-index: 1;\n  justify-content: flext-start;\n\n  > span {\n    &:first-child {\n      left: 0;\n    }\n    &:last-child {\n      right: 0;\n    }\n  }\n"])));
const ButtonWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  padding-left: ", ";\n  padding-right: ", ";\n"])), props => props.prefix && get('space.26'), props => props.suffix && get('space.26'));
const Components = {
  Area,
  ButtonWrapper,
  Prefix,
  Suffix,
  Wrapper
};
export { Components };